const oxygen_therapy_equipment = require("../../../assets/images/accessories/oxygen-therapy-equipment.jpg");
const suction_equipment = require("../../../assets/images/accessories/suction-equipment.jpg");
const central_gas_equipment = require("../../../assets/images/accessories/central-gas-equipment.jpg");
const probes_and_connectors = require("../../../assets/images/accessories/probes-and-connectors.jpg");

export const accessories_arr = [
  {
    accessoryType: "Oxygen Therapy Equipment",
    type: "Oxygen Therapy",
    image: oxygen_therapy_equipment,
  },
  {
    accessoryType: "Suction Equipment",
    type: "Suction",
    image: suction_equipment,
  },
  {
    accessoryType: "Central Gas Equipment",
    type: "Central Gases",
    image: central_gas_equipment,
  },
  {
    accessoryType: "Probes & Connectors",
    type: "Probes & Connectors",
    image: probes_and_connectors,
  },
];
